'use client';
import type { CalendarEvent } from '../../types/home.types';
import { formatDateBR, getEventDay } from '../../utils/dateFormatter';
import { MoreHorizontal, CalendarDays } from 'lucide-react';
import styles from './PlanningCard.module.css';
import { EmptyState } from '@practium/ui';

interface PlanningCardProps {
	events: CalendarEvent[];
	onEventClick?: (eventId: string) => void;
}

export const PlanningCard = ({ events, onEventClick }: PlanningCardProps) => {
	const hasEvents = events && events.length > 0;

	const handleEventClick = (eventId: string) => {
		if (onEventClick) {
			onEventClick(eventId);
		}
	};

	return (
		<div className={styles.planningCard}>
			<div className={styles.header}>
				<h3 className={styles.title}>Planejamento</h3>
				<button className={styles.menuButton} aria-label="More options">
					<MoreHorizontal size={17} color="var(--planning-meta)" />
				</button>
			</div>

			<div className={styles.eventsContainer}>
				{!hasEvents ? (
					<EmptyState
						icon={<CalendarDays size={48} />}
						title="Nenhum evento planejado"
						description="Seus próximos eventos aparecerão aqui"
					/>
				) : (
					events.map((event) => (
						<div
							key={event.id}
							className={styles.eventItem}
							onClick={() => handleEventClick(event.id)}
							role="button"
							tabIndex={0}
						>
							<div className={styles.eventDay}>
								<span className={styles.dayNumber}>{getEventDay(event.date)}</span>
							</div>
							<div className={styles.eventInfo}>
								<h4 className={styles.eventTitle}>{event.title}</h4>
								<p className={styles.eventDescription}>{event.description}</p>
							</div>
							<span className={styles.eventDate}>{formatDateBR(event.date)}</span>
						</div>
					))
				)}
			</div>
		</div>
	);
};
